<div
    *ngIf="mimic.type === 'mimicGroup'"
    (click)="$event.stopPropagation(); groupSelectedEmit(mimic)"
    [ngClass]="{
        link_active: isgroupActive(mimic.name)
    }"
    class="view-group-tab"
>
    <span data-cy="sidebar-mimics-expanded-label" class="dropdown-name">{{
        mimic.name
    }}</span>
</div>
<a
    data-cy="sidebar-mimics-expanded-item"
    *ngIf="mimic.type === 'mimic'"
    (click)="
        $event.stopPropagation(); toggleDropdownEmit(); onNavigateToEmit(mimic)
    "
    [ngClass]="{
        link_active: isActiveLink(mimic.id)
    }"
    class="view-container"
>
    <mat-icon class="view-icon"> insert_drive_file </mat-icon>
    <span class="dropdown-name">{{mimic.name }}</span>
</a>
